import { UPDATE_LOADING } from "../types";

const initialState = {
  loading: true,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
